import React,{useState,useEffect} from 'react';
import FormControl from '@mui/material/FormControl';
//import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

interface Props {
    value1: string,
    value2: string,
    name1: string,
    name2: string,
    id: string,
    index: number,
    error?: boolean,
    helper?:string,
	placeholder1?:string,
	placeholder2?:string,
    maxLength1?:number,
    minLength1?:number;
    maxLength2?:number,
    minLength2?:number;
	regex1?:string,
	regex2?:string,
    row?:boolean;
    change(name:string,index:number,value1:string,value2:string,hasError:boolean): void,
    addError?(name:string,flag:boolean): void,
}


const TwinInputString:React.FC<Props> = (props)=> {
	const [states,setStates] = useState({
		value1:props.value1,
		value2:props.value2,
		hasError1:false,
		hasError2:false,
	})

	const changeInput = (index:number) => (event: React.ChangeEvent<HTMLInputElement>) => {
        if( index===1 ){
			validate(event.target.value,states.value2);
        } else {
			validate(states.value1,event.target.value);
        }
    };
	const onBlur = ()=>{
		props.change(props.id,props.index,states.value1,states.value2,states.hasError1 || states.hasError2);
	}
	const validate = (value1:string,value2:string)=>{
		let error1 = false;
		let error2 = false;
		if( props.minLength1 ){
			if( value1.length<props.minLength1 ){
				error1  = true;
			}
		}
		if( props.maxLength1 ){
			if( value1.length>props.maxLength1 ){
				error1  = true;
			}
		}
		if( props.regex1 ){
			if( value1!=='' && !value1.match(props.regex1) ){
				error1 = true;
			}
		}

		if( props.minLength2 ){
			if( value2.length<props.minLength2 ){
				error2  = true;
			}
		}
		if( props.maxLength2 ){
			if( value2.length>props.maxLength2 ){
				error2  = true;
			}
		}
		if( props.regex2 ){
			if( value2!=='' && !value2.match(props.regex2) ){
				error2 = true;
			}
		}
		if( value1==='' && value2!=='' ){
			error1 = true;
		}
		if( value1!=='' && value2==='' ){
			error2 = true;
		}
		setStates({value1:value1,value2:value2,hasError1:error1,hasError2:error2});
	}

    let row = false;
    if( props.row!==null && props.row===true ){
        row = true;
    }

	let maxLength1 = 0;
	let classCounter1 = 'formCounter';
	let rest1 = 0;
	let maxLength2 = 0;
	let classCounter2 = 'formCounter';
	let rest2 = 0;

	if( props.maxLength1 ){
		maxLength1 = props.maxLength1;
		rest1 = maxLength1;
		const v = states.value1 as string;
		if( v ){
			rest1 -=  v.length;
			if( rest1<0 ){
				classCounter1 += " formCounterMinus";
			}
		}
	}
	if( props.maxLength2 ){
		maxLength2 = props.maxLength2;
		rest2 = maxLength2;
		const v = states.value2 as string;
		if( v ){
			rest2 -=  v.length;
			if( rest2<0 ){
				classCounter2 += " formCounterMinus";
			}
		}
	}

	useEffect(()=>{
		//console.log("twin",props.value1,props.value2);
		setStates({
			...states,
			value1:props.value1,
			value2:props.value2,
		});
	},[props.value1,props.value2])


    if( row ){
        return (
            <Grid container spacing={1} style={{marginBottom:'0.25em'}}>
                <Grid item xs={5} sm={3}>
                    <FormControl fullWidth={true}>
                        <TextField
                            id={"text1_"+props.id+"_"+String(props.index)}
                            value={states.value1}
                            onChange={changeInput(1)}
                            label={props.name1}
							placeholder={props.placeholder1}
                            variant="filled"
							onBlur={onBlur}
							error={states.hasError1}
                        />
						{maxLength1>0 &&
						<div className={classCounter1}>{rest1}</div>
						}						
                    </FormControl>
                </Grid>
                <Grid item xs={7} sm={9}>
                    <FormControl fullWidth={true}>
                        <TextField
                            id={"text2_"+props.id+"_"+String(props.index)}
                            value={states.value2}
                            onChange={changeInput(2)}
                            label={props.name2}
							placeholder={props.placeholder2}
                            variant="filled"
							onBlur={onBlur}
							error={states.hasError2}
                        />
						{maxLength2>0 &&
						<div className={classCounter2}>{rest2}</div>
						}
                    </FormControl>
                </Grid>
            </Grid>
        );    
    } else {
        return (
            <Grid container spacing={0} style={{marginBottom:"1em"}}>
                <Grid item xs={12}>
                    <FormControl fullWidth={true}>
                        <TextField
                            id={"text1_"+props.id+"_"+String(props.index)}
                            value={states.value1}
                            onChange={changeInput(1)}
							label={props.name1}
                            placeholder={props.placeholder1}
                            variant="filled"
							onBlur={onBlur}
							error={states.hasError1}
                        />
						{maxLength1>0 &&
						<div className={classCounter1}>{rest1}</div>
						}						
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth={true}>
                        <TextField
                            id={"text2_"+props.id+"_"+String(props.index)}
                            value={states.value2}
                            onChange={changeInput(2)}
							label={props.name2}
                            placeholder={props.placeholder2}
                            variant="filled"
							onBlur={onBlur}
							error={states.hasError2}
                        />
						{maxLength2>0 &&
						<div className={classCounter2}>{rest2}</div>
						}						
                    </FormControl>
                </Grid>
            </Grid>
        );    
    }
}

export default TwinInputString;
